export default "__VITE_ASSET__BbRil2_G__"